function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
var sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "cb-lottery"
  }, [_vm._l(_vm.rewardPreviewList, function (item, idx) {
    return _c('div', {
      key: 'preview' + idx,
      staticClass: "cb-lottery__item",
      class: {
        'is-active': idx + 1 === _vm.current
      },
      attrs: {
        "data-num": idx + 1
      }
    }, [_vm._t("default", function () {
      return [_c('img', {
        staticClass: "gift-img",
        attrs: {
          "src": item.img,
          "alt": "礼物图"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "gift-name"
      }, [_vm._v(_vm._s(item.name))])];
    }, {
      "item": item,
      "idx": idx
    })], 2);
  }), _vm._v(" "), _c('button', {
    staticClass: "cb-lottery__btn",
    on: {
      "click": _vm.requestLottery
    }
  })], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-39387ee4',
  render,
  name: 'CbSudokuTurntable',
  props,
  watch: {
    pos: {
      immediate: true,
      handler(newVal) {
        if (!Number.isNaN(Number.parseInt(newVal)) && newVal >= 1 && newVal <= 8) {
          this.current = newVal;
        }
      }
    },
    rewardPreviewList: {
      immediate: true,
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length) {
          this.poolMap.clear();
          newVal.forEach((v, idx) => {
            // 设置奖励的位置和奖励信息
            this.poolMap.set(String(v[this.rewardPk]), _extends({}, v, {
              num: idx + 1
            }));
          });
        }
      }
    }
  },
  data() {
    return {
      current: 1,
      isSpinning: false,
      poolMap: new Map()
    };
  },
  methods: {
    requestLottery() {
      var _this = this;
      return _asyncToGenerator(function* () {
        if (_this.isSpinning) {
          return;
        }
        _this.$emit('click');
        if (_this.lotteryDisabled) {
          return;
        }
        _this.isSpinning = true;
        _this.$emit('start');
        // 礼物所在的索引，读取的是后端返回的礼物索引
        try {
          var results = yield Promise.resolve(_this.request());
          var giftId = _this.getResponseGift(results)[_this.rewardPk].toString();
          var gift = _this.poolMap.get(giftId);
          if (!gift) {
            if (!_this.silence) {
              _this.toast('抽奖失败，请稍后再试试吧~');
              return;
            }
            throw new Error('抽奖结果不在奖励内容中');
          }
          var giftIdx = gift.num;
          yield _this.startAnimation(giftIdx);
          _this.$emit('success', gift);
        } catch (exp) {
          if (!_this.silence) {
            _this.toast('抽奖失败，请稍后再试试吧~');
          }
          _this.$emit('failed', exp);
        }
        _this.isSpinning = false;
      })();
    },
    getResponseGift(data) {
      return Array.isArray(data) && data.length >= 1 ? data[0] : data;
    },
    startAnimation(giftIdx) {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var loop = _this2.minLoop < 4 ? 4 : _this2.minLoop;
        // 转3圈，落在最终的礼物上，并且需要减去目前初始化的步数
        var steps = giftIdx + 8 * loop - _this2.current;
        var speedRate = _this2.speedRate;
        var times = Array.from({
          length: steps
        }).fill(30);
        // 将两头两尾的时间处理的更长一些
        for (var i = 0; i < speedRate.length; i++) {
          var cur = speedRate[i];
          times[i] = cur;
          times[times.length - 1 - i] = cur;
        }
        while (times.length) {
          _this2.current++;
          if (_this2.current > 8) {
            _this2.current = 1;
          }
          var tick = times.shift();
          yield sleep(tick);
        }
      })();
    },
    toast(msg) {
      typeof this.$toast === 'function' ? this.$toast(msg) : alert(msg);
    }
  }
});